import React from 'react';

import { useAppContext } from 'hooks/context/useAppContext';

import {
  PostBookingSurveyResponse,
  PostBookingSurveySchema,
} from 'types/post-booking-survey';

import { getClient } from 'utils/httpClient/httpClient.config';

type Response = {
  data: PostBookingSurveySchema[];
};

type PostBookingSurveyApi = (
  email: string,
  phone: string,
) => {
  data?: PostBookingSurveySchema;
  submitResponse: (
    token: string,
    response: PostBookingSurveyResponse['response'],
  ) => Promise<void>;
};

export const usePostBookingSurveyApi: PostBookingSurveyApi = (email, phone) => {
  const { config, publicUser } = useAppContext();
  const [data, setData] = React.useState<Response>();
  const url = `${config.apiUrlV3}/web/salons/${publicUser.slug}/surveys`;

  // fetch data only when email or phone exist
  // skip it for Rescheduling where email and phone aren't available

  React.useEffect(() => {
    const shouldFetch = email || phone;
    const getSurveyInfo = async () => {
      const response = await getClient().post<Response>(url, {
        email,
        phone,
      });

      setData(response.data);
    };

    if (shouldFetch) {
      void getSurveyInfo();
    }
    // To prevent unnecessary renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, phone]);

  async function submitResponse(
    token: string,
    response: PostBookingSurveyResponse['response'],
  ) {
    const payload = { client: { email, phone }, response };

    await getClient().post(`${url}/${token}/responses`, payload);
  }

  return { data: data?.data[0], submitResponse };
};
